import { fetcher } from '@commenda/utils';
import { LegacyDocumentType } from '@prisma/client';

export type CreateBusinessEntityDocumentParams = {
  documentSubType: LegacyDocumentType;
  fileUrl: string;
  fileName: string;
  effectiveStartDate?: string;
  effectiveEndDate?: string;
};

const createBusinessEntityDocument = async (
  businessEntityId: number,
  body: CreateBusinessEntityDocumentParams
) => {
  const response = await fetcher(
    `business-entities/${businessEntityId}/documents`,
    {
      method: 'POST',
      body,
    }
  );

  return response;
};

export { createBusinessEntityDocument };
